import { render, staticRenderFns } from "./FSOfficer.vue?vue&type=template&id=45f4d876&scoped=true"
import script from "./FSOfficer.vue?vue&type=script&lang=js"
export * from "./FSOfficer.vue?vue&type=script&lang=js"
import style0 from "./FSOfficer.vue?vue&type=style&index=0&id=45f4d876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f4d876",
  null
  
)

export default component.exports